import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import fetchAPI from 'utils/http/fetchAPI';
import handleError from 'utils/http/handleError';
import { EXPERIMENT_SETTINGS_EXCLUDE_GENES_DELETED } from 'redux/actionTypes/experimentSettings';
var deleteExcludeGenesFileUpload = function deleteExcludeGenesFileUpload(experimentId) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return fetchAPI("/v2/experiments/".concat(experimentId, "/excludeGenes"), {
              method: 'DELETE'
            });
          case 3:
            _context.next = 8;
            break;
          case 5:
            _context.prev = 5;
            _context.t0 = _context["catch"](0);
            handleError(_context.t0, 'Failed to delete excludeGenes file.');
          case 8:
            dispatch({
              type: EXPERIMENT_SETTINGS_EXCLUDE_GENES_DELETED,
              payload: {
                experimentId: experimentId
              }
            });
          case 9:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 5]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
export default deleteExcludeGenesFileUpload;